var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"40px"}},[_vm._v("Будет большой красивый монитор")])}
var staticRenderFns = []

export { render, staticRenderFns }